import { render } from "./ShippingModelSelectionForm.vue?vue&type=template&id=0d926bb6"
import script from "./ShippingModelSelectionForm.vue?vue&type=script&lang=js"
export * from "./ShippingModelSelectionForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__